import React, { useContext, useEffect } from 'react';
import { TextLink } from '@spotify-internal/encore-web';
import { useRouter } from 'next/router';

import analytics from 'utils/client/analytics/analytics';
import { BlockSerializerUbiContext } from 'lib/sanity/ui/BlockSerializerUbiProvider';
import { useUbiContext } from 'utils/ubi/ubiProvider';

const trackInlineLink = (href: string, action?: string) =>
  analytics.trackEvent({
    category: 'article-inline-link',
    action,
    label: href.replace(/https?:\/\//g, ''),
  });

const InlineLink = ({ href, children }: { href: string; children: React.ReactNode }) => {
  const ubiLogger = useUbiContext();
  const { query } = useRouter();
  const ubi = useContext(BlockSerializerUbiContext);
  useEffect(() => {
    ubi.logLinkImpression(href);
  }, [ubi, href, ubiLogger]);
  const { articleslug } = query;
  return (
    <TextLink
      onClick={() => {
        ubi.logLinkInteraction(href);
        trackInlineLink(href, articleslug as string);
      }}
      href={href}
    >
      {children}
    </TextLink>
  );
};
export default InlineLink;
